import { SearchResult } from '@rygen/rygen-ui/model';

import { Manifest } from './Manifest';

export class ManifestSearchResult extends SearchResult<Manifest> {
  content: Manifest[] = [];

  constructor(opts?: Partial<ManifestSearchResult>) {
    super(opts);

    if (opts?.content != null) {
      this.content = opts.content.map((val) => new Manifest(val));
    }
  }
}
